window.addEventListener("load", function() {
    $().ready(function(){
        $('#form' + idFormulari + ', .modificadorPlaces').on('submit change', function(event){
            if (event.type === 'submit') {
                event.preventDefault();
            }
            var modificadorPlaces = [];
            $('.modificadorPlaces').each(function(index){
                modificadorPlaces.push({'index': $(this).attr("name"),'valor': $(this).val()});
            });

            $.ajax({
                url: "/media/php/checkPlacesAjax.php",
                type: "post",
                data: {'idFormulari' : idFormulari, 'idPagina': idPagina, 'modificadorPlaces': modificadorPlaces},
                success: function(result
                ){
                    if(result <= 0){
                        $('.errorPlaces').remove();
                        var errorPlaces = $("<label class='errorPlaces error'></label>").text( "S'ha excedit el número màxim de places per aquesta franja i/o categoria.");
                        $('#form' + idFormulari).append(errorPlaces);
                        $('button[name="enviar"]').prop('disabled', true);
                        $('button[name="enviar"]').hide();
                    } else {
                        if (event.type === 'submit') {
                            return true;
                        }
                        $('.errorPlaces').remove();
                        $('button[name="enviar"]').prop('disabled', false);
                        $('button[name="enviar"]').show();
                    }
                }
            });
        });
    });
});
